import { useTranslation } from 'react-i18next';

import { Box, CardContent } from '@/shared/ui';
import { Button } from '@/shared/ui/lib/Button';
import { useNotifications } from '@/shared/ui/Notifications';
import { CustomTypography } from '@/shared/ui/Typography';

import { useForgotPassword } from '../model/useForgotPassword';

type TResendResetPasswordEmail = {
  email: string;
};

export const ResendResetPasswordEmail = ({
  email,
}: TResendResetPasswordEmail) => {
  const { t } = useTranslation();
  const { addNotification } = useNotifications();

  const { forgotPassword, isPending } = useForgotPassword();

  const onSubmit = async () => {
    await forgotPassword({ email }, () => {
      addNotification({
        type: 'success',
        title: t('auth:forgotPassword.successResendEmail.title'),
      });
    });
  };

  return (
    <Box sx={{ width: '100%', maxWidth: '450px' }}>
      <CardContent sx={{ textAlign: 'center' }}>
        <CustomTypography variant="h6" sx={{ mb: 2, mt: 2 }}>
          {t('auth:forgotPassword.infoCard.title')}
        </CustomTypography>

        <CustomTypography variant="subtitle2" fontWeight="regular">
          {t('auth:forgotPassword.infoCard.message1')}
          <CustomTypography variant="h4" component="span">
            {email}
          </CustomTypography>
        </CustomTypography>

        <CustomTypography variant="subtitle2" sx={{ mb: 2 }}>
          {t('auth:forgotPassword.infoCard.message2', {
            email: 'info@letsgochat.ru',
          })}
        </CustomTypography>

        <Button onClick={onSubmit} loading={isPending}>
          <CustomTypography variant="subtitle1">
            {t('auth:forgotPassword.infoCard.resendMail')}
          </CustomTypography>
        </Button>
      </CardContent>
    </Box>
  );
};
